export default __webpack_public_path__ + "static/fin-int-ai-f9de58b90d5c58116fa2a00f710d562f.png";